//states/login.js
import { make } from "vuex-pathify"

const state = {
  level: 8,
  elog: null
};

const mutations = make.mutations(state);


export default {
  namespaced: true,
  state,
  mutations
}